import * as React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const DownloadDocIcon = (props) => {
  const {fill = '#374151', other} = props;
  return (
    <SvgIcon {...props} width="18" height="18" viewBox="0 0 18 18" {...other}>
      <svg xmlns="http://www.w3.org/2000/svg" >
        <path fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M148,448v1a3,3,0,0,0,3,3h10a3,3,0,0,0,3-3v-1m-4-4-4,4m0,0-4-4m4,4V436" transform="translate(-147 -435)"/>
      </svg>

    </SvgIcon>
  );
};

export default DownloadDocIcon;
